import React from 'react';
import { useNavigate } from 'react-router-dom';
import './KrimaanCropPlanner.css';

const KrimaanCropPlanner = () => {
  const navigate = useNavigate();



  return (
    <>

    <div data-aos='fade-up' data-aos-duration='1000' className="krimaan-crop-planner">
      <h1 className='crop_planner_heading'>KRIMAAN Crop Planner</h1>
      <p>" If you are a gardener/farmer registered with us, you will get a crop planner that maximizes your profit and improves your soil's health."</p>
      <button onClick={() => navigate('/login')}>Login</button>
    </div>
    </>
  );
};

export default KrimaanCropPlanner;
